import { z } from "zod";
import { pinned } from "./pin";

export interface ChatReplyToPreview {
  id: string;
  content: string;
  senderId: string;
  senderName: string | null;
  imageUrl: string | null;
  listingId: string | null;
  orderId: string | null;
  sellerOrderId: string | null;
}

export const ChatReplyToPreviewSchema = pinned<ChatReplyToPreview>()(
  z.object({
    id: z.string().uuid(),
    content: z.string(),
    senderId: z.string(),
    senderName: z.string().nullable(),
    imageUrl: z.string().nullable(),
    listingId: z.string().uuid().nullable(),
    orderId: z.string().uuid().nullable(),
    sellerOrderId: z.string().uuid().nullable(),
  }),
);
